import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, change } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'
import { renderInputField, renderSelectField } from '../utils/forms'

import { blockMatrix } from '../actions/matrixs'
import { fetchArticles } from '../actions/articles'

class RemoteActionBaqueiraBlockLockerForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      actionCompleted: false,
      errorMessage: '',
      blockType: '',  // New state to track the selected BlockType
    }

    this.submit = this.submit.bind(this)
    this.handleBlockTypeSelect = this.handleBlockTypeSelect.bind(this)
  }

  componentDidMount() {
    this.props.fetchArticles();
  }

  handleBlockTypeSelect(blockType) {
    this.setState({ blockType })  // Set the selected BlockType in the state
  }

  // Modified submit function to include blockType
  submit = async (props) => {
    const { blockType } = this.state;

    if (blockType === '') {
      this.setState({ errorMessage: 'Por favor, selecciona un tipo de bloqueo.' });
      throw new SubmissionError({ _error: 'Por favor, selecciona un tipo de bloqueo.' });
    }

    // Add BlockType to the props for the API call
    props.BlockType = blockType;

    try {
      // Use blockMatrix function to send blockType to the server
      await this.props.blockMatrix(this.props.machine._id, blockType, this.props.lockerSN, this.props.lockerMatricula);

      // Handle other form submission logic here...

      this.setState({ loading: false, actionCompleted: true });

      if (this.props.updateBlockType) {
        this.props.updateBlockType(blockType);
      }
      
      // Trigger matrix data refresh
      if (this.props.refreshMatrixData) {
        this.props.refreshMatrixData();
      }

    } catch (error) {
      this.setState({ loading: false, errorMessage: error.message || 'Error processing action' });
      throw error;
    }
  }

  render() {
    const { error, pristine, submitting, handleSubmit, articles } = this.props;
    const { loading, actionCompleted, errorMessage, blockType } = this.state;

    // props.blockType is the locker's CURRENT whitelist (null = not blocked);
    // state.blockType is the pending selection.
    const isBlocked = this.props.blockType != null;

    if (!articles) {
      return (
        <div className="lm-state">
          <span className="lm-state-msg">Cargando artículos...</span>
          <LoadingProgress logoHeight={36} className="compact" />
        </div>
      );
    }

    if (loading) {
      return (
        <div className="lm-state">
          <span className="lm-state-msg">Ejecutando bloqueo...</span>
          <LoadingProgress logoHeight={36} className="compact" />
        </div>
      );
    }

    if (actionCompleted) {
      return (
        <div className="lm-alert-stack">
          <div className="lm-alert lm-alert-success">Taquilla bloqueada correctamente</div>
        </div>
      );
    }

    return (
      <div>
        <form onSubmit={handleSubmit(this.submit)} className="text-center">
          <label className="lm-field-label">Selecciona la lista blanca para la que quieres bloquear esta taquilla</label>
          <div className="whitelist-options mt-4 mb-4">
            {articles.Whitelist.map(whitelist => (
              <button
                key={whitelist._id}
                type="button"
                title={whitelist.name}
                className={`whitelist-btn ${this.state.blockType === whitelist._id ? 'whitelist-btn-selected' : ''}`}
                onClick={() => this.handleBlockTypeSelect(whitelist._id)}
              >
                <span className="whitelist-btn-label">{whitelist.name}</span>
                <span
                  className="whitelist-btn-swatch"
                  style={{ backgroundColor: whitelist.color }}
                ></span>
              </button>
            ))}
            <button
              type="button"
              disabled={!isBlocked}
              title={isBlocked ? 'Desbloquear' : 'Esta taquilla no está bloqueada para ninguna lista blanca'}
              className={`whitelist-btn whitelist-btn-unblock ${this.state.blockType === null ? 'whitelist-btn-selected' : ''}`}
              onClick={() => this.handleBlockTypeSelect(null)}
            >
              <span className="whitelist-btn-label">Desbloquear</span>
              <span className="whitelist-btn-swatch"></span>
            </button>
          </div>

          {blockType === '' && <span className="lm-field-error">Por favor selecciona un tipo de bloqueo.</span>}

          {/* Submit button */}
          <div className="lm-form-footer">
            <button className="lm-btn-cancel" type="button" onClick={this.props.closeMatrixDialog}>
              Cancelar
            </button>
            <button className="lm-btn-confirm" type="submit" disabled={submitting || blockType === ''}>
              <i className="fas fa-ban"></i>
              Confirmar bloqueo
            </button>
          </div>

          {/* Error message */}
          {error && <div className="lm-alert-stack">
            <div className="lm-alert lm-alert-danger">{error}</div>
          </div>}
        </form>
      </div>
    );
  }
}

RemoteActionBaqueiraBlockLockerForm = reduxForm({
  form: 'RemoteActionBaqueiraBlockLockerForm',
})(RemoteActionBaqueiraBlockLockerForm)

const mapStateToProps = state => ({
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
  articles: state.articles.articles,
})

const mapDispatchToProps = dispatch => ({
  blockMatrix: bindActionCreators(blockMatrix, dispatch),
  dispatch,
  fetchArticles: bindActionCreators(fetchArticles, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RemoteActionBaqueiraBlockLockerForm)
